import http from "@/util/http.js"
const PREFIX = "/report"

export default {
    async get( customConfig) {
        return await http.get(PREFIX + "", { params: { }, customConfig });
    },
    async post(query, customConfig)
    {
        return await http.post(PREFIX +  "" , query, { customConfig })
    },
    async empresa(text, page, size, customConfig)
    {
        return await http.get(PREFIX + '/empresa', { params: { page, text, size }, customConfig })
    },
    async grupo(text, page, size, customConfig) {
        return await http.get(PREFIX + "/grupo", { params: { page, text, size }, customConfig });
    },
};